"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isQueryOptionsObject(options) {
    return options && typeof options === 'object' && options.queryOptionsType !== undefined;
}
exports.default = isQueryOptionsObject;
//# sourceMappingURL=isQueryOptionsObject.js.map